export const dukanChecker = (source: string): string | undefined => {
  if (source?.includes('dukan')) {
    return source;
  }
};
